import axios from "axios";
import React, { useEffect, useState } from "react";
import AuditionAllIncome from "./Screen/AuditionaAlIncome";
import AuditionSchedule from "./Screen/AuditionSchedule";
import AuditionSingleIncome from "./Screen/AuditionSingleIncome";
import AuditionWallet from "./Screen/AuditionWallet";
import "./Screen/stylesScreen.css";
const AuditionMainDashboard = () => {
  return (
    <>
      <div className="card-bg px-3 py-2">
        <AuditionAllIncome />
      </div>

      {/* <div className="bg-dark px-3 pt-4 pb-1">
        <AuditionWallet />
      </div> */}

      <div className=" px-3 pt-4 pb-1 card-bg">
        <AuditionSchedule />
      </div>

      <div className="mb-3">
        <div className=" px-3 pt-4 pb-1 card-bg mt-3">
          <AuditionSingleIncome />
        </div>
      </div>
    </>
  );
};

export default AuditionMainDashboard;
